import React, { useState } from 'react';
import UserDetails from '../../common/model/UserDetails';
import { userContext } from '../Context/UserContext';

const UserDetailsProvider = ({ children }) => {

    const [user, setUser] = useState<any>();


    const setUserDetails = (data:UserDetails) => {
   
        setUser(data);
    }

    return (<userContext.Provider value={{ user: user, setUserDetails }}>
        { children}
    </userContext.Provider>)
}

export default UserDetailsProvider;